import {Icon} from '@udemy-v2/icons';
import {FormGroup, TextInputForm} from '@udemy-v2/react-form-components';
import {useI18n} from '@udemy-v2/i18n';
import React from 'react';

interface SearchWidgetProps {
    onSubmit: (value: string) => void;
    onClear: () => void;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    size?: 'small' | 'medium';
    submitButtonProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
}

export const SearchWidget = ({
    onSubmit,
    onClear,
    value,
    onChange,
    size = 'medium',
    submitButtonProps = {},
}: SearchWidgetProps) => {
    const {gettext} = useI18n();

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const searchTerm = value.trim();
        if (!searchTerm) {
            onClear();
        } else {
            onSubmit(searchTerm);
        }
    };

    const showClear = value !== '';

    return (
        <FormGroup
            label={gettext('Search reviews')}
            labelProps={{className: 'ud-sr-only'}}
            className={/*styles['search-form']*/ ''}
        >
            <TextInputForm
                submitButtonContent={<Icon glyph="search" label={gettext('Submit search')} />}
                submitButtonProps={submitButtonProps}
                onChange={onChange}
                onClearInput={onClear}
                onSubmit={handleFormSubmit}
                size={size}
                placeholder={gettext('Search reviews')}
                showClearInputButton={showClear}
                value={value}
            />
        </FormGroup>
    );
};
